export const SET_USERS = 'SET_USERS'
export const SET_USER = 'SET_USER'
export const SET_USER_HIGHLIGHT = 'SET_USER_HIGHLIGHT'
export const SET_CHECKED = 'SET_CHECKED'
export const RESET_USER = 'RESET_USER'
export const ADD_USER = 'ADD_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_ROLES = 'SET_ROLES'
export const SET_USER_ROLES = 'SET_USER_ROLES'
export const SET_PAGER = 'SET_PAGER'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_LOGOUT = 'SET_LOGOUT'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_HOVER = 'SET_HOVER'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_CURRENT = 'SET_CURRENT'
export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_USER_ORGANIZATIONS = 'SET_USER_ORGANIZATIONS'
export const SET_FOUND_USERS = 'SET_FOUND_USERS'
export const ADDTO_FOUND_USERS = 'ADDTO_FOUND_USERS'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const SET_USER_NOTES = 'SET_USER_NOTES'
export const SET_USER_NOTE = 'SET_USER_NOTE'
export const RESET_USER_NOTE = 'RESET_USER_NOTE'
export const SET_USER_NOTE_DATA = 'SET_USER_NOTE_DATA'

export const STORE_PAGER = 'user/pager'
export const STORE_TOKEN = 'user/token'
export const STORE_PROFILE = 'user/profile'
export const STORE_PAGER_ORG = 'organization/pager'
export const STORE_PAGER_CARDIO = 'usercardio/pager'
